import debounce from 'lodash/debounce';
import React, { FC, useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { appDataModel } from '@entities/app-data';
import { bookModel } from '@entities/book';
import { Textarea } from '@shared/ui';

export const DefaultTitlePage: FC = () => {
  const isOwner = useSelector(appDataModel.selectors.selectIsBookOwnerWithError);
  const dispatch = useDispatch();
  const book = useSelector(appDataModel.selectors.selectedBookWithError);

  const handleSaveTitle = (content: string, bookId: string) => {
    if (content !== '') {
      dispatch(
        bookModel.actions.saveBookDetailsAction({
          book: { ...book, title: content },
          bookId,
        })
      );
    }
  };
  const handleSaveSubtitle = (content: string, bookId: string) => {
    dispatch(
      bookModel.actions.saveBookDetailsAction({
        book: { ...book, subtitle: content },
        bookId,
      })
    );
  };
  const handleSaveAuthor = (content: string, bookId: string) => {
    dispatch(
      bookModel.actions.saveBookDetailsAction({
        book: { ...book, author: content },
        bookId,
      })
    );
  };
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleSaveTitle = useCallback(debounce(handleSaveTitle, 300), []);
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleSaveSubtitle = useCallback(debounce(handleSaveSubtitle, 300), []);
  //eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedHandleSaveAuthor = useCallback(debounce(handleSaveAuthor, 300), []);

  const handleChangeTitle = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    debouncedHandleSaveTitle(e.target.value, book.id);
  };
  const handleChangeSubtitle = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    debouncedHandleSaveSubtitle(e.target.value, book.id);
  };
  const handleChangeAuthor = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    debouncedHandleSaveAuthor(e.target.value, book.id);
  };

  const titleRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    titleRef.current?.focus();
  }, []);

  return (
    <div className='h-full px-4 pt-4 sm:p-0 bg-neutrals-0'>
      <div className='min-h-11'></div>
      <div className='flex flex-col items-center justify-center h-full gap-4 p-10 mx-auto max-w-170 bg-neutrals-0'>
        <Textarea
          className='text-l font-semibold text-center'
          name='title'
          placeholder='Enter a Title'
          ref={titleRef}
          disabled={!isOwner}
          defaultValue={book.title}
          onChange={handleChangeTitle}
        />
        <Textarea
          className='text-xs text-center'
          name='subtitle'
          placeholder='Enter a Subtitle (optional)'
          disabled={!isOwner}
          defaultValue={book.subtitle}
          onChange={handleChangeSubtitle}
        />
        <Textarea
          className='text-base leading-normal text-center'
          name='subtitle'
          placeholder='Enter an Author Name (optional)'
          disabled={!isOwner}
          defaultValue={book.author}
          onChange={handleChangeAuthor}
        />
      </div>
    </div>
  );
};
